import config from "./config"

/**
 * 生成指定长度随机数
 * @param length
 * @returns {string}
 */
export function makeRandom(length) {
  let str = "0123456789", ret = "";
  for (let i = 0; i < length; i++) {
    ret += str.substr(Math.floor(Math.random() * str.length), 1);
  }
  return ret;
}

/**
 * 根据条件返回数组指定元素
 * @param array
 * @param fn
 * @returns {null}
 */
export function arrayFind(array, fn) {
  let index = array.findIndex(fn);
  return index > -1 ? array[index] : null;
}

/**
 * 判断浏览器类型
 * @param name
 * iphone
 * android
 * micromessenger
 * @returns {boolean}
 */
export function isBrower(name) {
  let UA = window.navigator.userAgent.toLowerCase();
  return UA.indexOf(name) > -1;
}


export function getAppid(callback) {
  let hostname = url("hostname", callback);
  let appid = "";
  for (let key in config.appid) {
    if (hostname == key) {
      appid = config.appid[key];
    }
  }
  if (!appid) {
    appid = config.appid[Object.keys(config.appid)[0]];
  }
  return appid;
}

/**
 * 根据来源获得api_url
 * @param callback
 * @returns {string}
 */
export function getApiUrl(callback) {
  let hostname = url("hostname", callback);
  let api_url = "";
  for (let key in config.api_url) {
    if (hostname == key) {
      api_url = config.api_url[key];
    }
  }
  if (!api_url) {
    api_url = config.api_url[Object.keys(config.api_url)[0]];
  }
  return api_url;
}

/**
 * 生成跳转链接
 * @deprecated 跳转地址请使用 buildCallbackUrl（会重新编码 path/query/hash 并保留端口），
 * 未经 checkCallback 校验的地址不允许直接用于 location 赋值
 * @param options
 * @returns {string}
 */
export function makeUrl(options) {
  let url = "";
  if (options.protocol) {
    url += options.protocol + "://"
  }
  if (options.hostname) {
    url += options.hostname
  }
  if (options.port && options.port != 80 && options.port != 443) {
    url += ":" + options.port
  }
  if (options.path) {
    url += options.path
  }
  if (options.query) {
    let q = "";
    for (let key in options.query) {
      if (options.query[key]) {
        q += `&${key}=${encodeURIComponent(options.query[key])}`
      } else {
        q += `&${key}`
      }

    }
    q = q.substr(1);
    url += "?" + q
  }
  if (options.hash) {
    url += "#" + options.hash;
  }
  return url;
}

/**
 * 解析url参数
 * @param from
 * @returns {{protocol: *, hostname: *, port: *, path: *, query: *, hash: *}}
 */
export function getParamsFromUrl(from) {
  let protocol = url("protocol", from);
  let hostname = url("hostname", from);
  let port = url("port", from);
  let path = url("path", from);
  let query = url("?", from);
  let hash = url("hash", from);
  return {protocol, hostname, port, path, query, hash}
}

/**
 * 安全解码：解码失败时保留原始字符串，不抛异常
 * （js-url 的 query 解析遇到非法百分号编码会抛 URIError，导致整个页面挂载失败）
 * @param value
 * @returns {string}
 */
export function safeDecode(value) {
  if (typeof value !== "string") {
    return "";
  }
  try {
    return decodeURIComponent(value);
  } catch (e) {
    return value;
  }
}

/**
 * 解析 URL 的 query 参数
 * 每个参数值只解码一次（与浏览器行为一致），解码失败保留原值
 * @param href
 * @returns {object}
 */
export function parseQueryParams(href) {
  const params = {};
  if (!href || typeof href !== "string") {
    return params;
  }
  let rest = href;
  const hashIdx = rest.indexOf("#");
  if (hashIdx >= 0) {
    rest = rest.slice(0, hashIdx);
  }
  const queryIdx = rest.indexOf("?");
  if (queryIdx < 0) {
    return params;
  }
  rest.slice(queryIdx + 1).split("&").forEach(pair => {
    if (!pair) {
      return;
    }
    const eq = pair.indexOf("=");
    const key = safeDecode(eq >= 0 ? pair.slice(0, eq) : pair);
    if (!key) {
      return;
    }
    params[key] = eq >= 0 ? safeDecode(pair.slice(eq + 1)) : "";
  });
  return params;
}

/**
 * 解析 query 字符串为对象（值只解码一次）
 * @param qs
 * @returns {object}
 */
export function parseQueryString(qs) {
  const params = {};
  if (!qs || typeof qs !== "string") {
    return params;
  }
  qs.split("&").forEach(pair => {
    if (!pair) {
      return;
    }
    const eq = pair.indexOf("=");
    const key = safeDecode(eq >= 0 ? pair.slice(0, eq) : pair);
    if (!key) {
      return;
    }
    params[key] = eq >= 0 ? safeDecode(pair.slice(eq + 1)) : "";
  });
  return params;
}

/**
 * 严格解析 callback 地址
 * 只接受「scheme://host[:port]/path?query#hash」这种绝对地址，
 * 拒绝 userinfo（a@b 形式）、相对地址、协议相对地址以及任何 javascript:/data: 等伪协议
 * @param text 已经解码一次的 callback 文本
 * @returns {null|{scheme: string, hostname: string, port: string, path: string, query: object, hash: string}}
 */
export function parseCallbackUrl(text) {
  if (!text || typeof text !== "string") {
    return null;
  }
  // scheme://authority（authority 不允许出现 @ / ? # 空白）path?query#hash
  // path 中同样不允许出现 @：否则 https://白名单域名@evil.com/ 会被解析成
  // host=白名单域名、path=@evil.com/，重建后浏览器仍会跳到 evil.com
  const matched = text.match(/^([A-Za-z][A-Za-z0-9+.\-]*):\/\/([^\/?#\s@]+)([^?#@]*)(\?[^#]*)?(#[\s\S]*)?$/);
  if (!matched) {
    return null;
  }
  const scheme = matched[1].toLowerCase();
  const authority = matched[2];
  const portMatched = authority.match(/^([^:]+)(?::(\d{1,5}))?$/);
  if (!portMatched) {
    return null;
  }
  const hostname = portMatched[1].toLowerCase();
  if (!/^[a-z0-9]([a-z0-9\-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9\-]*[a-z0-9])?)*$/.test(hostname)) {
    return null;
  }
  let port = "";
  if (portMatched[2]) {
    port = String(parseInt(portMatched[2], 10));
    if (!port || port < 1 || port > 65535) {
      return null;
    }
  }
  return {
    scheme,
    hostname,
    port,
    path: matched[3] || "",
    query: parseQueryString(matched[4] ? matched[4].slice(1) : ""),
    hash: matched[5] ? matched[5].slice(1) : ""
  };
}

/**
 * 校验 callback 跳转地址
 * 只有「协议在白名单内」且「主机精确匹配白名单」的地址才允许跳转，
 * 避免 javascript:、data: 等伪协议通过 host 校验后被当作脚本执行（DOM XSS）
 * @param callback 已经解码一次的 callback 文本
 * @returns {{ok: boolean, msg: string, params: object}}
 */
export function checkCallback(callback) {
  if (!callback || typeof callback !== "string") {
    return {ok: false, msg: "callback 参数无效", params: null};
  }
  const params = parseCallbackUrl(callback);
  if (!params) {
    return {ok: false, msg: "callback 地址格式非法", params: null};
  }
  if (config.callback_protocols.indexOf(params.scheme) === -1) {
    return {ok: false, msg: `callback 协议"${params.scheme}"不在白名单内`, params: null};
  }
  if (config.callback_whitelist.indexOf(params.hostname) === -1) {
    return {ok: false, msg: `callback 主机"${params.hostname}"不在白名单内`, params: null};
  }
  return {ok: true, msg: "", params};
}

/**
 * 编码 path / hash 中的空白字符、控制字符与非 ASCII 字符
 * - path 与 hash 取自 callback 原文，本身已是 URL 编码形式（%20 等），
 *   若整体再编码一次会出现 %20 -> %2520 的重复编码，因此已有的合法 %XX 保持原样
 * - 孤立的 % （后面不是两位十六进制）编码为 %25，避免出现 100%%E6 这类歧义串
 * - 非 ASCII（中文、emoji 等）统一按 UTF-8 百分号编码，保证重建出的地址是纯 ASCII
 * @param text
 * @returns {string}
 */
function encodeUrlUnsafeChars(text) {
  const str = text || "";
  let out = "";
  for (let i = 0; i < str.length; i++) {
    const code = str.charCodeAt(i);
    if (code <= 32 || code === 127) {
      // 空白字符与控制字符
      const hex = code.toString(16).toUpperCase();
      out += "%" + (hex.length === 1 ? "0" + hex : hex);
    } else if (code === 37) {
      // '%'：仅当后面不是两位十六进制时才编码，已有 %XX 保持原样
      const isValidEscape = /^[0-9A-Fa-f]{2}$/.test(str.substr(i + 1, 2));
      out += isValidEscape ? '%' : '%25';
    } else if (code < 128) {
      out += str.charAt(i);
    } else {
      const next = i + 1 < str.length ? str.charCodeAt(i + 1) : 0;
      if (code >= 0xD800 && code <= 0xDBFF && next >= 0xDC00 && next <= 0xDFFF) {
        // 代理对（emoji 等）：整体编码，避免对半个代理对调用 encodeURIComponent 抛 URIError
        out += encodeURIComponent(str.substr(i, 2));
        i++;
      } else {
        try {
          out += encodeURIComponent(str.charAt(i));
        } catch (e) {
          const hex = code.toString(16).toUpperCase();
          out += "%" + (hex.length === 1 ? "0" + hex : hex);
        }
      }
    }
  }
  return out;
}

/**
 * 安全的 encodeURIComponent
 * 未配对的代理对等非法字符会让 encodeURIComponent 抛 URIError，
 * 这里逐字符降级编码，保证不会因为一个畸形参数导致整页挂载失败
 * @param value
 * @returns {string}
 */
function safeEncodeURIComponent(value) {
  const str = value == null ? "" : String(value);
  try {
    return encodeURIComponent(str);
  } catch (e) {
    let out = "";
    for (let i = 0; i < str.length; i++) {
      const code = str.charCodeAt(i);
      if (code >= 0xD800 && code <= 0xDBFF) {
        const next = i + 1 < str.length ? str.charCodeAt(i + 1) : 0;
        if (next >= 0xDC00 && next <= 0xDFFF) {
          out += encodeURIComponent(str.substr(i, 2));
          i++;
        } else {
          out += "%" + code.toString(16).toUpperCase();
        }
      } else if (code >= 0xDC00 && code <= 0xDFFF) {
        out += "%" + code.toString(16).toUpperCase();
      } else {
        out += encodeURIComponent(str.charAt(i));
      }
    }
    return out;
  }
}

/**
 * 生成 query 字符串，键值均做编码
 * @param query
 * @returns {string}
 */
function buildQueryString(query) {
  let str = "";
  for (let key in query) {
    if (!Object.prototype.hasOwnProperty.call(query, key)) {
      continue;
    }
    const value = query[key];
    str += "&" + safeEncodeURIComponent(key) + (value ? "=" + safeEncodeURIComponent(value) : "");
  }
  return str.substr(1);
}

/**
 * 依据校验通过的 callback 组件重建跳转地址
 * 所有路径、query、hash 都会重新编码，保证重建结果与校验结果一致
 * @param params checkCallback 返回的 params
 * @param extra 需要追加的 query 参数（如 openid、t）
 * @returns {string}
 */
export function buildCallbackUrl(params, extra) {
  if (!params) {
    return "";
  }
  let target = params.scheme + "://" + params.hostname;
  if (params.port) {
    target += ":" + params.port;
  }
  target += encodeUrlUnsafeChars(params.path);
  const query = Object.assign({}, params.query, extra || {});
  const qs = buildQueryString(query);
  if (qs) {
    target += "?" + qs;
  }
  if (params.hash) {
    target += "#" + encodeUrlUnsafeChars(params.hash);
  }
  return target;
}

/**
 * 校验最终要跳转的地址是否安全（协议 + 主机双重校验，作为跳转前的最后一道防线）
 * @param target
 * @returns {boolean}
 */
export function isSafeRedirect(target) {
  if (!target || typeof target !== "string") {
    return false;
  }
  const res = checkCallback(target);
  return res.ok;
}

/**
 * 生成query字符串
 * @param query
 * @returns {string}
 */
export function queryBuilder (query) {
  if (typeof query !== 'object') {
    return ''
  }
  let queryStr = ''
  for (let key in query) {
    queryStr += `&${key}=${encodeURIComponent(query[key])}`
  }
  return queryStr.substr(1)
}



// WEBPACK FOOTER //
// ./src/lib/util.js